import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useTenantStore } from '../stores/useTenantStore';

interface AuthInitializerProps {
  children: React.ReactNode;
}

const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const auth = useAuth();
  const { restoreToken, isConfigured, reset } = useTenantStore();
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialisation : synchronise auth.user → store au démarrage
  useEffect(() => {
    if (auth.isLoading) return;

    if (auth.user?.id_token) {
      restoreToken(auth.user.id_token).then(() => {
        setIsInitialized(true);
      });
    } else {
      if (isConfigured) {
        reset();
      }
      setIsInitialized(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoading, auth.user]);

  // Renouvellement silencieux automatique → met à jour le token dans le store
  useEffect(() => {
    return auth.events.addUserLoaded((user) => {
      if (user?.id_token) {
        useTenantStore.getState().restoreToken(user.id_token);
      }
    });
  }, [auth.events]);

  if (!isInitialized || auth.isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #E85D04',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ color: '#666', margin: 0 }}>Initialisation...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthInitializer;
